import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { content } from "@/i18n/content";

const LangContext = createContext(null);

function detect() {
  const saved = localStorage.getItem("daios_lang");
  if (saved === "pt" || saved === "en") return saved;
  const nav = (navigator.language || "pt").toLowerCase();
  return nav.startsWith("en") ? "en" : "pt";
}

export function LangProvider({ children }) {
  const [lang, setLang] = useState(detect);

  useEffect(() => {
    localStorage.setItem("daios_lang", lang);
    document.documentElement.lang = lang === "en" ? "en" : "pt-BR";
  }, [lang]);

  const value = useMemo(() => ({
    lang,
    setLang,
    toggle: () => setLang((l) => (l === "pt" ? "en" : "pt")),
    t: content[lang],
  }), [lang]);

  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);
